// @ts-check

import { ROUTE_LAYOUT, ROUTE_NAME } from '@/router/meta'
import { useLanguageStore } from '@/store/language'
import BaseViewVisitor from '@/views/BaseViewVisitor.vue'

/** @type {import('vue-router').RouteRecordRaw[]} */
export const loginRoutes = [
  {
    path: '/',
    redirect: { name: 'login' },
    name: 'root',
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'root'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginForm.vue'),
    props: true,
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'login'
    }
  },
  {
    path: '/login2', // Remove this route after WordPress url's have been updated
    name: 'login2',
    redirect: { name: 'login' },
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'login2'
    }
  },
  {
    path: '/en/login',
    beforeEnter: async (to, from, next) => {
      const { changeLanguage } = useLanguageStore()
      await changeLanguage('en')
      next({ name: 'login' })
    },
    component: () => import('@/views/LoginForm.vue'),
    meta: {
      showInMainNaw: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'login_en'
    }
  },
  {
    path: '/en/login2', // Remove this route after WordPress url's have been updated
    name: 'login2_en',
    beforeEnter: async (to, from, next) => {
      const { changeLanguage } = useLanguageStore()
      await changeLanguage('en')
      next({ name: 'login' })
    },
    component: () => import('@/views/LoginForm.vue'),
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'login2_en'
    }
  }
]

export default loginRoutes
